(function Module() {
	'use strict';

mySynch.filter('interpolate',function ($interpolate,$sce) {
    return function (source, scope,event) {
       return $sce.trustAsHtml($interpolate(source)(scope));
    };
});

mySynch.filter('compile',function ($compile) {
    return function (source, scope,event) {
       return $compile(source)(scope)[0];
    };
});

mySynch.filter('safeSpecialCharFilter', ['$filter', function($filter) {
    return function (input, valueType) {
        
        if(_.isUndefined(input) || _.isUndefined(input) || !_.isString(input)){return input;}
        var charMaps = [
            { placeholder:"#SingleQuote#",character:"'"},
            { placeholder:"#DoubleQuote#",character:'"'},
            { placeholder:"#Hyphen#",character:'-'},
            { placeholder:"#Colon#",character:':'},
            { placeholder:"#Comma#",character:','},
        ]; 
        
        switch(valueType) {
            case 'escape':
                _.forEach(charMaps,function(charMap){
                    
                    input = input.replace(new RegExp(charMap.character,"g"),charMap.placeholder);
                });   
                return input;
            case 'unescape':
                _.forEach(charMaps,function(charMap){
                    
                    input = input.replace(new RegExp(charMap.placeholder,"g"),charMap.character);
                });
                return  input;
            default:
                return input;
        }
    };
}]);


})();